import { createMutation } from '@tanstack/svelte-query';
import { createRoom, deleteRoom, updateRoom } from '$lib/api/room';
import {
	invalidateAfterRoomCreate,
	invalidateAfterRoomDelete
} from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { RoomRequest, RoomResponse } from '$lib/types/room';

export const createRoomMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<RoomResponse, Error, RoomRequest>(() => ({
		mutationFn: (request) => createRoom(request),
		onSuccess: () => invalidateAfterRoomCreate(resolveScope(scope))
	}));

export const updateRoomMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<RoomResponse, Error, { id: number; request: RoomRequest }>(() => ({
		mutationFn: ({ id, request }) => updateRoom(id, request),
		onSuccess: () => invalidateAfterRoomCreate(resolveScope(scope))
	}));

export const deleteRoomMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<void, Error, number>(() => ({
		mutationFn: (id) => deleteRoom(id),
		onSuccess: () => invalidateAfterRoomDelete(resolveScope(scope))
	}));
